<!--
 * @Author: 俊昌 junchang.zhang@wahool.com
 * @Date: 2024-01-23 11:01:34
 * @LastEditors: 俊昌 junchang.zhang@wahool.com
 * @LastEditTime: 2024-01-26 18:27:44
 * @FilePath: /flowBusinessui/src/views/integrated/settings/index.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <a-spin :spinning="spinning">
    <div class="settingsBox">
      <div class="pageTitle">{{ t('Amazon.storeSetting') }}</div>
      <div class="descBox">
        <span class="descTitle">{{ t('Amazon.orderOpaction') }}</span>
        <span class="descIcon">*</span>
      </div>
      <div class="selectList">
        <div class="selectItem" v-for="(item, index) in settingsRef.fulfillmentAction" :key="item.code" @click="agreement(index)">
          <div class="leftCon">
            <span>{{ item.showDesc }}</span>
            <!-- {{ item.desc }} -->
          </div>
          <img v-if="item.selected" src="~@/assets/images/amazon/selectActive.png" alt="" />
          <img v-else src="~@/assets/images/amazon/select.png" alt="" />
        </div>
      </div>
      <div class="descBox descBox-top33">
        <span class="descTitle">{{ t('Amazon.orderShipMess') }}</span>
        <span class="descIcon">*</span>
      </div>
      <div class="selectList">
        <div class="selectItem" v-for="(item, index) in settingsRef.shippingSpeedCategory" :key="index" @click="transportation(index)">
          <div class="leftCon">
            <span>{{ item.showDesc }}</span>
          </div>
          <img v-if="item.selected" src="~@/assets/images/amazon/selectActive.png" alt="" />
          <img v-else src="~@/assets/images/amazon/select.png" alt="" />
        </div>
      </div>
      <div class="remarkBox">
        <div class="remarkTitle">
          <span class="descTitle">{{ t('Amazon.orderRemarkMess') }}</span>
          <span class="descIcon">*</span>
        </div>
        <div class="remarkInput">
          <a-input style="width: 100%; height: 45px" v-model:value="remarkValue" :placeholder="t('Amazon.placeOrderRemaekMess')" :showCount="true" :maxlength="255" />
          <span class="spanNum">{{ remarkValue.length }}/255</span>
        </div>
      </div>
      <div class="btns" @click="submit">{{ t('Amazon.settingMess') }}</div>
    </div>
  </a-spin>
</template>
<script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { authorizationAmazonApi } from '@/api/financial.js'
  import { useI18n } from 'vue-i18n'
  import { getSettingsTemplate, setSettings, getAuthInfo } from '@/api/supplier/amazon/amazon.js'
  let { t, locale } = useI18n()
  const remarkValue = ref('') //备注信息
  const spinning = ref(false) // loading状态
  import { message } from 'ant-design-vue'
  const settingsRef = ref({}) //设置页面数据
  const codeRef = ref('') //店铺code
  const route = useRoute()
  const router = useRouter()
  onMounted(async () => {
    try {
      // 从亚马逊跳过来的
      if (route.query?.spapi_oauth_code) {
        const res = await authorizationAmazonApi({
          state: route.query?.state,
          sellingPartnerId: route.query?.selling_partner_id,
          spApiOauthCode: route.query?.spapi_oauth_code,
          storeIdCode: JSON.parse(sessionStorage.getItem('storeIdCodes'))
        })
        spinning.value = false
        if (res.code === 200) {
          // amazonInfo.value = res.data
          // 绑定完成后去掉url参数，避免刷新的情况
          window.history.replaceState({}, document.title, '/' + 'integrated/Settings')
        } else {
          message.error(`${res?.message}`)
        }
      } else {
        spinning.value = false
      }
      if (route.query?.id) {
        codeRef.value = route.query?.id
      }
    } catch (error) {}
  })
  //获取配置数据
  const getSettingList = async () => {
    const res = await getSettingsTemplate()
    console.log(res, 'res-123123')
    settingsRef.value = res.data
    if (route.query.id) {
      getStoreInfo()
    }
  }
  getSettingList()
  //查询绑定记录回显数据
  const getStoreInfo = () => {
    getAuthInfo(route.query.id).then(res => {
      console.log(res, '获取绑定记录数据')
      remarkValue.value = res.data.displayableOrderComment
      settingsRef.value.fulfillmentAction = res.data.amazonAccountSettingEnums.fulfillmentAction
      settingsRef.value.shippingSpeedCategory = res.data.amazonAccountSettingEnums.shippingSpeedCategory
    })
  }
  //履约
  const agreement = index => {
    if (settingsRef.value.fulfillmentAction[index].selected) return
    settingsRef.value.fulfillmentAction.map(item => {
      item.selected = false
    })
    settingsRef.value.fulfillmentAction[index].selected = !settingsRef.value.fulfillmentAction[index].selected
  }
  //运输
  const transportation = index => {
    if (settingsRef.value.shippingSpeedCategory[index].selected) return
    settingsRef.value.shippingSpeedCategory.map(item => {
      item.selected = false
    })
    settingsRef.value.shippingSpeedCategory[index].selected = !settingsRef.value.shippingSpeedCategory[index].selected
  }
  //点击提交
  const submit = () => {
    const item1 = settingsRef.value.fulfillmentAction.filter(item => item.selected)
    const item2 = settingsRef.value.shippingSpeedCategory.filter(item => item.selected)
    if (item1.length == 0) {
      return message.error(t('Amazon.placeSelectOpac'))
    } else if (item2.length == 0) {
      return message.error(t('Amazon.placeSelectShip'))
    }
    let payload = {
      fulfillmentAction: item1[0].code,
      shippingSpeedCategory: item2[0].code,
      displayableOrderComment: remarkValue.value
    }
    //codeRef有值说明是在amazon列表页面过来的，否则就是授权页面过来的
    if (codeRef.value) {
      payload['id'] = codeRef.value
    } else {
      payload['storeIdCode'] = JSON.parse(sessionStorage.getItem('storeIdCodes'))
    }
    setSettings(payload).then(res => {
      console.log(res, 'res-12123123123ssssss')
      if (res.code == 200) {
        router.push({
          path: '/integrated/Amazon'
        })
      }
    })
  }
</script>
<style lang="less" scoped>
  .btns {
    margin-top: 50px;
    border-radius: 8px;
    border: 1px solid #e4e4e4;
    background: #000;
    width: 253px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .settingsBox {
    width: 100%;
    padding: 0 32px;
    margin-top: 24px;
    .pageTitle {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
    .descBox {
      margin-top: 24px;
      display: flex;
      .descTitle {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
      }
      .descIcon {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        color: #fb5d43;
      }
    }
    .descBox-top33 {
      margin-top: 33px;
    }
    .selectList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .selectItem {
        cursor: pointer;
        margin-top: 28px;
        width: 47%;
        height: 45px;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(170, 170, 170, 0.3);
        padding: 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftCon {
          span {
            font-size: 14px;
            font-weight: 700;
            line-height: 145%;
          }
          font-size: 14px;
          font-weight: 400;
          line-height: 145%;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .remarkBox {
      margin-top: 55px;
      .remarkTitle {
        display: flex;
        .descTitle {
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
        }
        .descIcon {
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
          color: #fb5d43;
        }
      }
      .remarkInput {
        height: 45px;
        margin-top: 20px;
        width: 100%;
        position: relative;
        .spanNum {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0, -50%);
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
</style>
